import template from 'lodash-es/template'

import { useAuthStore } from '@/feature/auth/store/auth'

import { SWROptions } from '@/lib/core/hooks/usePaginatedNetworkResource'
import { ResponseError } from '@/lib/core/interfaces/common.types'

import { useNetworkRequest } from '@/lib/utils/request'

export const createNetworkRequestHook = <
  DataType,
  RequestPayload extends Record<string, unknown> | null | undefined =
    | Record<string, unknown>
    | null
    | undefined,
  Response extends DataType = DataType,
  Error = ResponseError,
  SWRConfig extends SWROptions<Response, Error> = SWROptions<Response, Error>,
>(
  baseUrl: string,
) => {
  const urlTemplate = template(baseUrl)
  return (params?: RequestPayload | null | undefined, swrOptions?: SWRConfig) => {
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

    return useNetworkRequest<Response, Error, { fallbackData: Response } & SWRConfig>(
      params === null || !isAuthenticated
        ? null
        : {
            url: urlTemplate({ params }),
            config: {
              params,
            },
          },
      {
        ...swrOptions,
      } as { fallbackData: Response } & SWRConfig,
    )
  }
}
